import { z } from 'zod'
import { env } from '@/lib/env'

export const brandIdSchema = z.enum(['wwjd', 'christspiracy'])

export type BrandId = z.infer<typeof brandIdSchema>

export const BRAND_CONFIG = {
  christspiracy: {
    name: 'Christspiracy',
    canonicalOrigin: 'https://christspiracy.com',
    lettermark: 'Christspiracy',
    wordmark: 'Christspiracy',
    faviconPath: '/christspiracy-favicon.svg',
    siteThumbnailPath: '/christspiracy-site-thumbnail.webp',
    xPixelId: env.NEXT_PUBLIC_X_PIXEL_ID_CHRISTSPIRACY,
    xPixelPurchaseEventId: env.NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_CHRISTSPIRACY,
    baseTitle: '{{brand_name}}: The Spirituality Secret | OFFICIAL WEBSITE',
    baseDescription:
      '{{brand_name}} is a thrilling, eye-opening documentary that reveals the most explosive cover-up in 2,000 years. Co-directed by award-winning filmmaker Kip Andersen (Netflix: Cowspiracy 2014, What the Health 2017, Seaspiracy 2021) and Kameron Waters.',
    baseDescriptionSocial:
      'WATCH NOW FOR A LIMITED TIME: A groundbreaking documentary revealing the biggest cover-up in the last 2,000 years.',
    ogImageTagline: 'THE BIGGEST COVER-UP IN 2,000 YEARS',
  },
  wwjd: {
    name: 'What Would Jesus Do?',
    canonicalOrigin: 'https://wwjdfilm.com',
    lettermark: 'WWJD?',
    wordmark: 'What Would Jesus Do?',
    faviconPath: '/wwjd-favicon.svg',
    siteThumbnailPath: '/wwjd-site-thumbnail.webp',
    xPixelId: env.NEXT_PUBLIC_X_PIXEL_ID_WWJD,
    xPixelPurchaseEventId: env.NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_WWJD,
    baseTitle: '{{brand_name}}: OFFICIAL WEBSITE',
    baseDescription:
      '{{brand_name}} is a thrilling, eye-opening documentary that reveals the most explosive cover-up in 2,000 years. Co-directed by award-winning filmmaker Kip Andersen (Netflix: Cowspiracy 2014, What the Health 2017, Seaspiracy 2021) and Kameron Waters.',
    baseDescriptionSocial:
      'WATCH NOW FOR A LIMITED TIME: A groundbreaking documentary revealing the biggest cover-up in the last 2,000 years.',
    ogImageTagline: 'THE BIGGEST COVER-UP IN 2,000 YEARS',
  },
} as const satisfies Record<BrandId, unknown>

export type BrandKey = keyof typeof BRAND_CONFIG
export type BrandConfig = (typeof BRAND_CONFIG)[BrandKey]

export const BRAND_DOMAINS = {
  production: {
    'christspiracy.com': 'christspiracy',
    'www.christspiracy.com': 'christspiracy',
    'wwjdfilm.com': 'wwjd',
    'www.wwjdfilm.com': 'wwjd',
  },
  localhost: {
    3000: 'wwjd',
    3001: 'christspiracy',
  },
  previewKeywords: ['wwjd', 'christspiracy'],
  default: 'christspiracy',
} as const satisfies {
  production: Record<string, BrandId>
  localhost: Record<number, BrandId>
  previewKeywords: readonly BrandId[]
  default: BrandId
}
